<template>
  <main class="flex min-h-full">
    <div class="flex-1 h-auto flex flex-row">
      <div class="w-full flex flex-col justify-center laptop:w-1/2">
        <img
          src="/images/eventor-logo.svg"
          alt="Eventor"
          class="max-w-250 w-full mx-auto my-40"
        >
        <Transition
          name="fade-medium"
          mode="out-in"
          appear
        >
          <RouterView class="w-full max-w-500 mx-auto py-40 px-20 laptop:max-w-600" />
        </Transition>
      </div>
      <AuthAside class="hidden h-full w-1/2 tablet:block" />
    </div>
  </main>
</template>

<script>
import AuthAside from '@/components/auth/AuthAside';

export default {
  components: {
    AuthAside,
  },
};
</script>

<style>
</style>
